import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckAuth } from 'src/Services/utility.service';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { TRFAUpdateGetModel, TRFAUpdateModel } from 'src/Models/TRFAUpdateModel';
import { StateMasterService } from 'src/Services/state-master.service';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { TRFAFundModel } from 'src/Models/TRFAFundModel';
import { TrfaUpdateMasterService } from 'src/Services/trfa-update--master.service';
import { TrfaFundMasterService } from 'src/Services/trfa-fund-master.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class UpdateComponent implements OnInit {

  stateCode: any;
  tokenKey: string;
  listofUpdate: TRFAUpdateGetModel[];
  listofUpdateExport: TRFAUpdateGetModel[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  Note: string;

  upDowNoteCSS: string = '';
  upDownfundNameCSS: string = '';
  upDowStateNameCSS: string = '';
  upDowUpdateDateCSS: string = '';
  upDowFundTypeCSS: string = '';
  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  listOfStateIds = [];
  stateId: string = ' ';
  stateList: StateMasterModel[] = [];
  //Fund
  fundID: string = ' ';
  dropdownListFund = [];
  selectedItemsFund = [];
  dropdownSettingsFund = {};
  listOffundIDs = [];
  fundList: TRFAFundModel[] = [];
  module = "TRFA";
  stateIds: string = ' ';
  UpdateId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly trfaUpdateMaster: TrfaUpdateMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly stateService: StateMasterService,
    private readonly trfaFundMaster: TrfaFundMasterService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofUpdate = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'UpdateDate desc';
    this.Note = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Updates');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsFund = {
      singleSelection: false,
      text: "Filter by Fund",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Fund(s) available',
      showCheckbox: true
    };
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.getState();
    this.getFund();
    this.isloading = true;
    this.GetUpdate();
  }

  getFund() {
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.trfaFundMaster.GetFundV2(this.tokenKey, this.stateId, true, true).subscribe(
      data => {
        this.dropdownListFund = []
        this.fundList = data['fund'];
        this.dropdownListFund = data['fund'];
        this.selectedItemsFund = [];
        if (this.fundList.length > 0) {
          let b = [];
          this.selectedItemsFund = [];
          this.fundList.forEach(x => {
            let a = this.listOffundIDs.filter(e => e == x.fundID);
            if (a.length > 0) {
              b.push(x.fundID);
              this.selectedItemsFund.push(x)
            }
          });
          this.listOffundIDs = b;
        }
        else {
          this.selectedItemsFund = [];
          this.listOffundIDs = [];
        }
      },
      error => { }
    );
  }
  
  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetUpdate();
  }

  GetUpdate() {
    this.isloading = true;
    this.listofUpdate = [];
    this.fundID = ' ';
    if (this.listOffundIDs.length > 0) {
      this.fundID = this.listOffundIDs.join(',')
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    if (this.Note == "null") this.Note = " ";
    this.trfaUpdateMaster.GetAllUpdateV2(this.tokenKey, this.PageNumber, this.PageSize, this.fundID, this.stateId, this.OrderBy, false).subscribe(
      data => {
        this.isloading = false;
        this.listofUpdate = data['update'];
        if (this.listofUpdate != null) {
          if (this.listofUpdate.length == 0) {
            this.isRecord = true;
            this.totalRecordCount = 0;
          }
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofUpdate[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );
  }

  keywordFilters($event) {
    if ($event.target.value != "" && $event.target.value != null)
      this.Note = $event.target.value;
    else
      this.Note = 'null';

    this.resetPageNoandSize();
    this.GetUpdate();
  }

  sort(sortBy: string) {
    this.upDowUpdateDateCSS = '';
    this.upDowFundTypeCSS = '';
    this.upDownfundNameCSS = '';
    this.upDowStateNameCSS = '';
    this.upDowNoteCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "Note") {
        this.upDowNoteCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "FundName") {
        this.upDownfundNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "FundTypeName") {
        this.upDowFundTypeCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "StateName") {
        this.upDowStateNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "Note") {
        this.upDowNoteCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "FundName") {
        this.upDownfundNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "FundTypeName") {
        this.upDowFundTypeCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "StateName") {
        this.upDowStateNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateDateCSS = 'fa fa-arrow-up';
      }
    }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  addUpdate() {
    let navigation = '/admin/' + this.SelectedTool + '/update/manage';
    this.router.navigate([navigation]);
  }

  updateUpdate(UpdateId) {
    let navigation = '/admin/' + this.SelectedTool + '/update/manage/' + UpdateId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id) {
    this.UpdateId = id;
  }

  deleteUpdate(UpdateId) {
    this.isloading = true;
    this.trfaUpdateMaster.DeleteUpdate(this.tokenKey, UpdateId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          // if (data['message'] != "")
          //   this.showMessage(data['message'], 'Warning', 'warning')
          // else
          this.showMessage("Update Deleted successfully", 'Success', 'success')
        }
        this.resetPageNoandSize();
        this.GetUpdate();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelectState($event) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    setTimeout(() => {
    this.GetUpdate();  
    }, 300);
    
  }

  onDeSelectState($event) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onSelectAll($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onDeSelectAllState($event) {
    this.listOfStateIds = [];
    this.getFund();
    this.resetPageNoandSize();
    this.GetUpdate();
  }


  onSelectFund($event) {
    this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, $event.id)
    this.listOffundIDs.push($event.id);
    // this.stateId = ' ';
    // if (this.listOffundIDs.length > 0) {
    //   this.stateId = this.listOffundIDs.join(',')
    // }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onDeSelectFund($event) {
    if (this.listOffundIDs != null) {
      if (this.listOffundIDs.length > 0) {
        this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, $event.id)
      }
    }
    if (this.listOffundIDs.length > 0) {
      this.stateId = this.listOffundIDs.join(',')
    }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onSelectAllFund($event) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
          this.listOffundIDs.push(item.id);
        }
        else {
          this.listOffundIDs.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onDeSelectAllFund($event) {
    this.listOffundIDs = [];
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }
      },
      error => { }
    );
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  onFilterSelectAllState($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onFilterDeSelectAllState($event) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onFilterSelectAllFund($event) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
          this.listOffundIDs.push(item.id);
        }
        else {
          this.listOffundIDs.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  onFilterDeSelectAllFund($event) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetUpdate();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportTRFAUpdates() {
    this.isloading = true;
    this.listofUpdateExport = [];
    this.fundID = ' ';
    if (this.listOffundIDs.length > 0) {
      this.fundID = this.listOffundIDs.join(',')
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    if (this.Note == "null") this.Note = " ";
    this.trfaUpdateMaster.GetAllUpdateV2(this.tokenKey, this.PageNumber, this.PageSize, this.fundID, this.stateId, this.OrderBy, true).subscribe(
      data => {
        this.listofUpdateExport = data['update'];
        if (this.listofUpdateExport != null) {
          if (this.listofUpdateExport.length > 0) {
            setTimeout(() => {
              this.DownloadTRFAUpdates();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadTRFAUpdates() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportTRFAUpdates';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTRFAUpdates.xls");
  }
}
